import type { TodayResponse } from '@pulse/contracts';
import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '@/lib/api-client';

/** Today for a business date (TOD-1 to TOD-8). */
export function useToday(date: string, today: string) {
  return useQuery({
    queryKey: ['pages', 'today', date],
    queryFn: () => apiRequest<TodayResponse>('/api/pages/today', { searchParams: { date: date === today ? undefined : date } }),
    staleTime: 60_000,
  });
}
